export const RESET_STATE_ACTION_TYPE = "resetState";
export const RESET_ERROR = "resetErrors";

export type TAsyncActionType = {
  loading: boolean;
  success: boolean;
  successMessage: string;
};
